
export default class DateTime {
	// 返回年月日
	static timestampToTime (timestamp) {
		if (!timestamp) return timestamp;
		timestamp.length === 13 || (timestamp = timestamp * 1000);
		let  date = new Date(timestamp);
		let Y = date.getFullYear() + "-";
		let M = (date.getMonth()+1 < 10 ? "0"+(date.getMonth()+1) : date.getMonth()+1) + "-";
		let D = date.getDate() < 10 ? ("0" + date.getDate()) : date.getDate() + " ";
		return Y+M+D;
	}
}

